module.exports = __webpack_public_path__ + "static/img/avater.1bc8b204.jpg";